"use client";

import { withFallback } from "../with-fallback";

export const ResetAccountElement = withFallback({
	displayName: "ResetAccountElement",
	type: "reset-account-element",
} as const);
